module.exports = __webpack_public_path__ + "static/img/logo89.ac48818.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo89.png
// module id = Lsjt
// module chunks = 1